import React from 'react';
import PropTypes from 'prop-types';
import './View.css';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Confirm from '../confirm/Confirm';
import CustomerService from '../../service/CustomerService';

class CopyDocumentsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fromCustomerId: '',
      toCustomerId: '',
      status: undefined,
      open: false,
    };

    this.handleFromCustomerIdChange = this.handleFromCustomerIdChange.bind(this);
    this.handleToCustomerIdChange = this.handleToCustomerIdChange.bind(this);
    this.statefulInitialization = this.statefulInitialization.bind(this);
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  FROM_INPUT_ID = 'view.copydocuments.text.from';

  TO_INPUT_ID = 'view.copydocuments.text.to';

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleClose = () => {
    this.setState({ open: false, });
  };

  handleFromCustomerIdChange(event) {
    this.setState({ fromCustomerId: event.target.value, });
  }

  handleToCustomerIdChange(event) {
    this.setState({ toCustomerId: event.target.value, });
  }

  statefulInitialization(customerProfile) {
    this.setState({
      fromCustomerId: customerProfile.id,
    });
  }

  submitCopyDocuments({ fromCustomerId, toCustomerId, }) {
    this.reset();
    if (this.isValid(fromCustomerId) && this.isValid(toCustomerId)) {
      this.setState({ isLoading: true, });

      CustomerService.copyDocuments({
        fromCustomerId,
        toCustomerId,
      })
        .then((response) => {
          const { copiedDocuments, failedDocuments, redundantDocuments, } = response.data;

          if (copiedDocuments.length + failedDocuments.length + redundantDocuments.length > 0) {
            this.setState({
              status: (
                <div className="card">
                  <div className="card-header">Results</div>
                  <div className="card-body">
                    Documents with fileRefs&nbsp;
                    <strong>
                      [
                      {failedDocuments.join(', ')}
                      ]&nbsp;FAILED.
                    </strong>
                    <br />
                    Documents with fileRefs&nbsp;[
                    <strong>
                      {redundantDocuments.join(', ')}
                    </strong>
                    ]&nbsp;already existed under new customer id.
                    <br />
                    Successfully copied documents with fileRefs&nbsp;[
                    <strong>
                      {copiedDocuments.join(', ')}
                    </strong>
                    ]&nbsp;to customer with id&nbsp;
                    <strong>
                      {toCustomerId}
                    </strong>
                    .
                  </div>
                </div>
              ),
            });
          }
        })
        .catch(() => {
          this.setState({
            status: (
              <Alert dismissible className="mt-2" variant="danger">
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>{`Unable to copy documents from [${fromCustomerId}] to [${toCustomerId}]`}</p>
              </Alert>
            ),
          });
        })
        .finally(() => {
          this.handleClose();
          this.setState({ isLoading: false, });
        });
    }
  }

  isValid(input) {
    if (!input || input === '' || /^\s*$/.test(input)) {
      return false;
    }
    return true;
  }

  reset() {
    this.setState({
      status: undefined,
    });
  }

  render() {
    const vm = this;
    const {
      fromCustomerId,
      toCustomerId,
      isLoading = false,
      open,
      status,
    } = this.state;
    return (
      <div className="content mt-2">
        <Form>
          <Form.Group className="mb-3" controlId={vm.FROM_INPUT_ID}>
            <Form.Label>From</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter current customer id"
              onChange={this.handleFromCustomerIdChange}
              value={fromCustomerId}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId={vm.TO_INPUT_ID}>
            <Form.Label>To</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter new customer id"
              onChange={this.handleToCustomerIdChange}
              value={toCustomerId}
            />
          </Form.Group>
          <Button variant="primary" onClick={this.handleClickOpen}>
            Copy Documents
          </Button>
          <Confirm
            isLoading={isLoading}
            title="Copy Documents Confirmation"
            content="Are you sure you want to copy documents?"
            open={open}
            onClose={this.handleClose}
            onYes={() => this.submitCopyDocuments({ fromCustomerId, toCustomerId, })}
            onNo={this.handleClose}
          />
        </Form>
        <br />
        <hr />
        {status}
      </div>
    );
  }
}

CopyDocumentsView.defaultProps = {
  requestedState: undefined,
};

CopyDocumentsView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default CopyDocumentsView;
